import 'intersection-observer';
import React from 'react';
import { InView } from 'react-intersection-observer';
export const ConditionalImpressionObserver = ({
  onImpression,
  children
}) => !!onImpression ?
/*#__PURE__*/
// eslint-disable-line
React.createElement(InView, {
  as: "div",
  onChange: inView => {
    if (inView) {
      onImpression();
    }
  },
  triggerOnce: true,
  threshold: 0.5
}, children) : children;